class customGlobalScript {
  constructor() {
    this.init();
  }

  clickEvents = () => {
    // header search
    ["change", "keyup"].forEach(function(type){
      document.querySelector('.field.form-floating input[type="search"]').addEventListener(type, (e) => {
        var val = e.target.value;
        if(val != null && val != '') {
          document.querySelector('.search__button .ts-search').classList.remove('d-inline-flex');
          document.querySelector('.search__button .ts-search').classList.add('d-none');
        } else {
          document.querySelector('.search__button .ts-search').classList.add('d-inline-flex');
          document.querySelector('.search__button .ts-search').classList.remove('d-none');
        }
      });
    }); 

    document.addEventListener('click', (e) => {
      if(e.target && e.target.classList.contains('snize-instant-widget-is-open')) {
        siteOverlay.prototype.hideOverlay();
      } else if(e.target && e.target.classList.contains('modal__close-button')) {
        siteOverlay.prototype.hideOverlay();
      } else if(e.target && e.target.id === "redirectToMainMenu") {
        if(document.querySelector('.submenu.dropdown-menu.bg-white.toggle-content.open') != null && window.screen.width <=991) {
          document.querySelector('.submenu.dropdown-menu.bg-white.toggle-content.open').click();
        } 
      }
    })


    var data_not_open_menu = document.querySelector('#data_not_open_menu');
    if(data_not_open_menu != undefined) {
      data_not_open_menu.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = data_not_open_menu.getAttribute('href');
      })
    }
  }

  footerKlaviyoJSLoad = () => {
    var scriptLoaded = false;
    window.addEventListener('scroll', function() {
      if(!scriptLoaded) {
        if (window.scrollY >= ((document.body.clientHeight - window.innerHeight) - document.querySelector('footer').offsetHeight)) {
          var s = document.createElement("script");
          s.type = "text/javascript";
          s.src = "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js";
          document.head.appendChild(s);
          setTimeout(function(){
            KlaviyoSubscribe.attachToForms('#email_signup', {
              hide_form_on_success: true,
              extra_properties: {
                $source: '$embed',
                $method_type: "Klaviyo Form",
                $method_id: 'embed',
                $consent_version: 'Embed default text'
              },
              success: function ($form) {
                $form.find('[for="customerPassword"]').hide();
              }
            });
          }, 2000);
          scriptLoaded = true;
        }
      }
    })
  }

  onLoadHeightIssues = () => {
    // header height issues
    var topBarHeight = document.querySelector('.site-header .topbar').offsetHeight
    var newHeight = -topBarHeight -1;
    document.querySelector('.navbar-collapse .header-logo-wrapper').style.top = `${newHeight}px`;
    document.querySelector('.navbar-collapse .header-logo-wrapper').style.marginBottom = `${newHeight}px`;
    document.querySelector('.navbar-collapse .header-logo-wrapper span').style.paddingTop = `${topBarHeight}px`;
    (document.querySelector('.header-slider .fullheight .swiper-slide') != null) && (document.querySelector('.header-slider .fullheight .swiper-slide').style.height = `calc(100vh - 101px - ${topBarHeight}px)`);

    // article and blog page sticky sidebar heigh issue
    if (document.querySelector('.sidebar-blog.overflow-hidden.sticky-top') != null) {
      window.addEventListener('scroll', function() {
        if(document.querySelector('.shopify-section-header-hidden.shopify-section-header-sticky .navbar.navbar-main.navbar-expand-lg') != null) {
          var headerHeight = document.querySelector('.shopify-section-header-hidden.shopify-section-header-sticky .navbar.navbar-main.navbar-expand-lg').offsetHeight;
          document.querySelector('.sidebar-blog.overflow-hidden.sticky-top').style.top = `${headerHeight + 10}px`;
        } else {
          document.querySelector('.sidebar-blog.overflow-hidden.sticky-top').style.top = `unset`;
        }
      })
    }
  }

  cartPageStickyButtons = () => {
    if (window.screen.width <= 991 && document.querySelector('.cart_summary_wrappers') != null) {
      window.addEventListener('scroll', function() {
        if ((window.scrollY + window.innerHeight) >= (document.querySelector('.cart_summary_wrappers').offsetTop)) {
          document.querySelector('.cart-footer-buttons').classList.remove('cart-footer-buttons-sticky');
        } else {
          document.querySelector('.cart-footer-buttons').classList.add('cart-footer-buttons-sticky')
        }
      })
    }
  }

  loadJqueryOnHomePage = () => {
    var scriptLoadedJquery=true;
    const that = this;
    document.addEventListener('scroll', function () {
        if (document.querySelector('#stamped-main-widget') != null) {
            const stampedMainWidget = document.querySelector('#stamped-main-widget');
            let visible = that.isInViewport(stampedMainWidget) ? 1 : 0;
            if (visible && scriptLoadedJquery) {
                scriptLoadedJquery=false;
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = "https://code.jquery.com/jquery-3.6.0.min.js";
                document.head.appendChild(s);
            }
        }
    });
  }

  isInViewport = (el) => {
      const rect = el.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  }

  setAnimationCount = () => {
    document.querySelector('#animationCount').classList.remove('d-none');
    var obj = document.querySelector('#animationCount');
    var start = 0;
    var end = parseInt(document.querySelector('#animationCount').innerHTML);
    var duration = 2000;
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }
  // modalClose = () => {
  //   let modalCloseElement = document.querySelectorAll('.recipe-popup');
  //   for(let i=0; i<modalCloseElement.length; i++){
  //     modalCloseElement[i].querySelector('.close-btn').addEventListener('click', (event) =>{
  //       event.preventDefault();
  //       modalCloseElement[i].querySelector('.modal').classList.remove('open');
       
  //     });
  //   }
  // }

  init = () => {
    this.onLoadHeightIssues();
    this.clickEvents();
    this.footerKlaviyoJSLoad();
    this.cartPageStickyButtons();
    this.loadJqueryOnHomePage();
    document.querySelector('#animationCount') != null && this.setAnimationCount();
    // this.modalClose();
  }
}

// search on hover hide cross button
document.querySelector('.snize-input-style').addEventListener('mouseover', function(event){
  if(this.value.length > 0){
      document.querySelector('.search__button .ts-search').classList.add('d-none')
  }else{
      document.querySelector('.search__button .ts-search').classList.remove('d-none')
  }
})


new customGlobalScript;